<div class="uk-container">
  <h5 class="uk-margin-medium-top uk-text-center">{{ message }}</h5>
  <pre *ngIf="error">{{ error }}</pre>
</div>


<div *ngIf="loading" class="whiteFilm">
  <i class="loader-big" aria-hidden="true"></i>
</div>
